export const DashboardNumber = (props) => {
    const { text, value } = props
    return (
        <div className="flex justify-between bg-slate-200 border rounded-xl p-4 w-full h-[85px] font-semibold">
            <div className="mt-[15px] text-slate-500">{text}</div>
            <div className="mt-[15px]">{value}</div>
        </div>
    )
}
